document.addEventListener('DOMContentLoaded', function() {
    function rearrangeMiniCart() {
        var cartProducts = document.querySelectorAll('#cart-info .ajaxcart__product');
        cartProducts.forEach(function(cartItem) {
            var price = cartItem.querySelector('.product-price');
            var bottom = cartItem.querySelector('.cart__item-bottom');
            var removeBtn = cartItem.querySelector('.remove-from-cart');
            
            if (price && bottom && removeBtn) {
                // Check if price is not inside bottom
                if (!bottom.contains(price)) {
                    bottom.appendChild(price);
                    bottom.classList.add('justify-content-between');
                }
                
                // Check if removeBtn is inside bottom
                if (bottom.contains(removeBtn)) {
                    bottom.parentNode.insertBefore(removeBtn, bottom);
                }
            }
        });
    }

    // Run initially just in case it's already there
    rearrangeMiniCart();

    // Setup MutationObserver to watch for AJAX cart updates
    var cartInfoNode = document.getElementById('cart-info');
    if (cartInfoNode) {
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length > 0) {
                    rearrangeMiniCart();
                }
            });
        });
        observer.observe(cartInfoNode, { childList: true, subtree: true });
    }
});

// Redirect ALL cart openings & Add to Cart events directly to Razorpay Sidecart
(function () {
    // Check if Razorpay Sidecart script is loaded and ready
    function isRazorpayReady() {
        return typeof window.__init_magic_sidecart__ !== 'undefined' ||
            !!document.querySelector('iframe[src*="razorpay"]') ||
            !!document.querySelector('.rzp-sidecart-checkout') ||
            !!window.__rzp_sidecart;
    }

    function openShopifyThemeCart() {
        var desktopCart = document.getElementById('desktop_cart');
        if (desktopCart) desktopCart.classList.add('active');
        var overlay = document.querySelector('.sidebar-overlay');
        if (overlay) overlay.classList.add('act');
        document.body.classList.add('open-canvans-cart');
    }

    function closeShopifyThemeCart() {
        var desktopCart = document.getElementById('desktop_cart');
        if (desktopCart) desktopCart.classList.remove('active');
        if (typeof sidebarOverlay !== 'undefined' && sidebarOverlay.removeClass) {
            sidebarOverlay.removeClass('act');
        }
        var overlay = document.querySelector('.sidebar-overlay');
        if (overlay) overlay.classList.remove('act');
        document.body.classList.remove('open-canvans-cart');
    }

    function triggerRazorpayCart() {
        var triggerLink = document.getElementById('rzp-sidecart-direct-trigger');
        if (!triggerLink) {
            triggerLink = document.createElement('a');
            triggerLink.id = 'rzp-sidecart-direct-trigger';
            triggerLink.href = '/cart';
            triggerLink.style.display = 'none';
            triggerLink.setAttribute('aria-hidden', 'true');
            // Prevent browser page navigation to /cart if Razorpay hasn't handled the click
            triggerLink.addEventListener('click', function (evt) {
                if (!evt.defaultPrevented) {
                    evt.preventDefault();
                }
            });
            document.body.appendChild(triggerLink);
        }

        function dispatchClick() {
            closeShopifyThemeCart();
            var evt = new MouseEvent('click', {
                bubbles: true,
                cancelable: true,
                view: window
            });
            triggerLink.dispatchEvent(evt);
        }

        if (isRazorpayReady()) {
            dispatchClick();
        } else {
            // If Razorpay is still loading after page reload, open Shopify theme cart as immediate feedback
            openShopifyThemeCart();

            // Poll every 100ms for up to 3 seconds until Razorpay is ready, then automatically switch to Razorpay
            var attempts = 0;
            var pollInterval = setInterval(function () {
                attempts++;
                if (isRazorpayReady()) {
                    clearInterval(pollInterval);
                    dispatchClick();
                } else if (attempts >= 30) {
                    clearInterval(pollInterval);
                }
            }, 100);
        }
    }

    // 1. Capture header cart clicks in the capturing phase
    document.addEventListener('click', function (e) {
        var cartBtn = e.target.closest('.site-header__cart, .header-cart, .contentsticky_cart, .mobile_cart .cart_canvas');
        if (cartBtn && !e.target.closest('#desktop_cart')) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();

            triggerRazorpayCart();
        }
    }, true);

    // 2. Observe #desktop_cart element for 'active' class added by Add-to-Cart scripts
    function initDesktopCartObserver() {
        var desktopCart = document.getElementById('desktop_cart');
        if (!desktopCart) return;

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    if (desktopCart.classList.contains('active')) {
                        triggerRazorpayCart();
                    }
                }
            });
        });
        observer.observe(desktopCart, { attributes: true, attributeFilter: ['class'] });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDesktopCartObserver);
    } else {
        initDesktopCartObserver();
    }

    // 3. Intercept fetch calls to /cart/add.js
    var originalFetch = window.fetch;
    if (originalFetch) {
        window.fetch = function () {
            var url = arguments[0];
            var isAddCart = typeof url === 'string' && url.indexOf('/cart/add') !== -1;
            return originalFetch.apply(this, arguments).then(function (response) {
                if (isAddCart && response.ok) {
                    setTimeout(function () {
                        triggerRazorpayCart();
                    }, 250);
                }
                return response;
            });
        };
    }

    // 4. Intercept jQuery $.ajax calls to /cart/add.js
    if (window.jQuery) {
        jQuery(document).ajaxComplete(function (event, xhr, settings) {
            if (settings && settings.url && settings.url.indexOf('/cart/add') !== -1) {
                setTimeout(function () {
                    triggerRazorpayCart();
                }, 250);
            }
        });
    }
})();